import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { PageHeader, Spinner, useApiQuery } from '@/modules/common';
import { Routes } from '@/router/routes';

import { useGcrFormOptions } from '../api';
import { GcrsTable } from '../components';
import { GcrFileItem } from '../types';

export const GcrsPage: FC = () => {
  const navigate = useNavigate();
  const { optionsData, isFetchingPrinters } = useGcrFormOptions();

  const { isFetching, data } = useApiQuery<{ items: GcrFileItem[] }>(
    '/gcrs?pageSize=1000',
    {
      queryKey: ['gcrs'],
      initialData: { items: [] },
    }
  );

  const redirectToGcrDetails = (item) => {
    navigate(Routes.GcrDetails.replace(':id', item.id));
  };

  return (
    <div>
      <PageHeader
        title="GCR Files"
        actions={[
          <Link to={Routes.NewGcr} key="new-gcr" data-testid="add-new-gcr-link">
            <Button
              disabled={isFetching || isFetchingPrinters}
              data-testid="add-new-gcr-button"
            >
              <PlusSquareIcon />
              Add new GCR file
            </Button>
          </Link>,
        ]}
      />

      {isFetching || isFetchingPrinters ? (
        <Spinner />
      ) : (
        <GcrsTable
          data={data.items}
          onClick={redirectToGcrDetails}
          options={optionsData}
        />
      )}
    </div>
  );
};
